import { Products } from '../../types/lucid-theme';
import { isPhoneSeparatorCharacter } from '../validators/regex';
import isBrowser from '../isBrowser';

const defaultEMEANumbers = {
  chart: '31 (20) 399-1900',
  spark: '31 (10) 899-0377',
};

const defaultAPACNumbers = {
  chart: '61 (8) 7701-9662',
  spark: '61 (8) 9126-6760',
};

const defaultUKNumbers = {
  chart: '44 (115) 697-1822',
  spark: '44 (156) 254-8917',
};

const defaultNZNumbers = {
  chart: '61 (3) 8777-0435',
  spark: '61 (3) 8777-0430',
};

const defaultAustraliaNumbers = {
  chart: '61 (3) 8777-0435',
  spark: '61 (3) 8777-0430',
};

const defaultNANumbers = {
  chart: '(855) 917-2480',
  spark: '(855) 929-2480',
};

const emeaNumbers = {
  AD: {
    country: 'Andorra',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  AE: {
    country: 'United Arab Emirates',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  AF: {
    country: 'Afghanistan',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  AL: {
    country: 'Albania',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  AM: {
    country: 'Armenia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  AO: {
    country: 'Angola',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  AQ: {
    country: 'Antarctica',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  AT: {
    country: 'Austria',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  AX: {
    country: 'Åland Islands',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  AZ: {
    country: 'Azerbaijan',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  BA: {
    country: 'Bosnia and Herzegovina',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  BE: {
    country: 'Belgium',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  BF: {
    country: 'Burkina Faso',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  BG: {
    country: 'Bulgaria',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  BH: {
    country: 'Bahrain',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  BI: {
    country: 'Burundi',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  BJ: {
    country: 'Benin',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  BL: {
    country: 'Saint Barthélemy',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  BV: {
    country: 'Bouvet Island',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  BW: {
    country: 'Botswana',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  BY: {
    country: 'Belarus',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  CD: {
    country: 'Congo, the Democratic Republic of the',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  CF: {
    country: 'Central African Republic',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  CG: {
    country: 'Congo',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  CH: {
    country: 'Switzerland',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  CI: {
    country: "Côte d'Ivoire",
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  CK: {
    country: 'Cook Islands',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  CM: {
    country: 'Cameroon',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  CV: {
    country: 'Cabo Verde',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  CW: {
    country: 'Curaçao',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  CY: {
    country: 'Cyprus',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  CZ: {
    country: 'Czechia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  DE: {
    country: 'Germany',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  DJ: {
    country: 'Djibouti',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  DK: {
    country: 'Denmark',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  DZ: {
    country: 'Algeria',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  EE: {
    country: 'Estonia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  EG: {
    country: 'Egypt',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  EH: {
    country: 'Western Sahara',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  ER: {
    country: 'Eritrea',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  ES: {
    country: 'Spain',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  ET: {
    country: 'Ethiopia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  FI: {
    country: 'Finland',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  FO: {
    country: 'Faroe Islands',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  FR: {
    country: 'France',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GA: {
    country: 'Gabon',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GB: {
    country: 'United Kingdom of Great Britain and Northern Island',
    region: 'EMEA',
    number: defaultUKNumbers,
  },
  GE: {
    country: 'Georgia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GF: {
    country: 'French Guiana',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GG: {
    country: 'Guernsey',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GH: {
    country: 'Ghana',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GI: {
    country: 'Gibralta',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GL: {
    country: 'Greenland',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GM: {
    country: 'Gambia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GN: {
    country: 'Guinea',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GP: {
    country: 'Guadeloupe',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GQ: {
    country: 'Equatorial Guinea',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GR: {
    country: 'Greece',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  HM: {
    country: 'Heard Island and McDonald Islands',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  HR: {
    country: 'Croatia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  HU: {
    country: 'Hungary',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  IE: {
    country: 'Ireland',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  IL: {
    country: 'Israel',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  IM: {
    country: 'Isle of Man',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  GW: {
    country: 'Guinea-Bissau',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  IQ: {
    country: 'Iraq',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  IR: {
    country: 'Iran, Islamic Republic of',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  IS: {
    country: 'Iceland',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  IT: {
    country: 'Italy',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  JE: {
    country: 'Jersey',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  JO: {
    country: 'Jordan',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  KE: {
    country: 'Kenya',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  KG: {
    country: 'Kyrgyzstan',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  KM: {
    country: 'Comoros',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  KW: {
    country: 'Kuwait',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  KZ: {
    country: 'Kazakhstan',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  LB: {
    country: 'Lebanon',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  LI: {
    country: 'Liechtenstein',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  LR: {
    country: 'Liberia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  LS: {
    country: 'Lesotho',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  LT: {
    country: 'Lithuania',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  LU: {
    country: 'Luxembourg',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  LV: {
    country: 'Latvia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  LY: {
    country: 'Libya',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  MA: {
    country: 'Morocco',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  MC: {
    country: 'Monaco',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  MD: {
    country: 'Moldova, Republic of',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  ME: {
    country: 'Montenegro',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  MF: {
    country: 'Collectivity of Saint Martin',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  MG: {
    country: 'Madagascar',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  MK: {
    country: 'Macedonia, the former Yugoslav Republic of',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  ML: {
    country: 'Mali',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  MQ: {
    country: 'Martinique',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  MR: {
    country: 'Mauritania',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  MT: {
    country: 'Malta',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  MU: {
    country: 'Mauritius',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  MW: {
    country: 'Malawi',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  MZ: {
    country: 'Mozambique',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  NA: {
    country: 'Namibia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  NC: {
    country: 'New Caledonia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  NE: {
    country: 'Niger',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  NG: {
    country: 'Nigeria',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  NL: {
    country: 'Netherlands',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  NO: {
    country: 'Norway',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  OM: {
    country: 'Oman',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  PF: {
    country: 'French Polynesia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  PL: {
    country: 'Poland',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  PM: {
    country: 'Saint Pierre and Miquelon',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  PS: {
    country: 'Palestine, State of',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  PT: {
    country: 'Portugal',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  QA: {
    country: 'Qatar',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  RE: {
    country: 'Réunion',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  RO: {
    country: 'Romania',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  RS: {
    country: 'Serbia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  RU: {
    country: 'Russian Federation',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  RW: {
    country: 'Rwanda',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SA: {
    country: 'Saudi Arabia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SC: {
    country: 'Seychelles',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SD: {
    country: 'Sudan',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SE: {
    country: 'Sweden',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SH: {
    country: 'Saint Helena, Ascension and Tristan da Cunha',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SI: {
    country: 'Slovenia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SK: {
    country: 'Slovakia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SL: {
    country: 'Sierra Leone',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SM: {
    country: 'San Marino',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SN: {
    country: 'Senegal',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SO: {
    country: 'Somalia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SS: {
    country: 'South Sudan',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  ST: {
    country: 'Sao Tome and Principe',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SX: {
    country: 'Sint Maarten',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SY: {
    country: 'Syrian Arab Republic',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  SZ: {
    country: 'Swaziland',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  TD: {
    country: 'Chad',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  TF: {
    country: 'French Southern Territories',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  TG: {
    country: 'Togo',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  TJ: {
    country: 'Tajikistan',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  TM: {
    country: 'Turkmenistan',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  TN: {
    country: 'Tunisia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  TR: {
    country: 'Turkey',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  TZ: {
    country: 'Tanzania, United Republic of',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  UA: {
    country: 'Ukraine',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  UG: {
    country: 'Uganda',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  UZ: {
    country: 'Uzbekistan',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  VA: {
    country: 'Holy See',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  WF: {
    country: 'Wallis and Futuna',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  YE: {
    country: 'Yemen',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  YT: {
    country: 'Mayotte',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  ZA: {
    country: 'South Africa',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  ZM: {
    country: 'Zambia',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
  ZW: {
    country: 'Zimbabwe',
    region: 'EMEA',
    number: defaultEMEANumbers,
  },
};

const latamNumbers = {
  AG: {
    country: 'Antigua and Barbuda',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  AI: {
    country: 'Anguilla',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  AR: {
    country: 'Argentina',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  AW: {
    country: 'Aruba',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  BB: {
    country: 'Barbados',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  BM: {
    country: 'Bermuda',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  BO: {
    country: 'Bolivia, Plurinational State of',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  BR: {
    country: 'Brazil',
    region: 'LATAM',
    number: defaultNANumbers,
  },
  BS: {
    country: 'Bahamas',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  BZ: {
    country: 'Belize',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  CL: {
    country: 'Chile',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  CO: {
    country: 'Colombia',
    region: 'LATAM',
    number: defaultNANumbers,
  },
  CR: {
    country: 'Costa Rica',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  CU: {
    country: 'Cuba',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  DM: {
    country: 'Dominica',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  DO: {
    country: 'Dominican Republic',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  EC: {
    country: 'Ecuador',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  FK: {
    country: 'Falkland Islands (Malvinas)',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  GD: {
    country: 'Grenada',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  GS: {
    country: 'South Georgia and the South Sandwich Islands',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  GT: {
    country: 'Guatemala',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  GY: {
    country: 'Guyana',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  HN: {
    country: 'Honduras',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  HT: {
    country: 'Haiti',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  JM: {
    country: 'Jamaica',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  KN: {
    country: 'Saint Kitts and Nevis',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  KY: {
    country: 'Cayman Islands',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  LC: {
    country: 'Saint Lucia',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  MS: {
    country: 'Montserrat',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  MX: {
    country: 'Mexico',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  NI: {
    country: 'Nicaragua',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  PA: {
    country: 'Panama',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  PE: {
    country: 'Peru',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  PR: {
    country: 'Puerto Rico',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  PY: {
    country: 'Paraguay',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  SR: {
    country: 'Suriname',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  SV: {
    country: 'El Salvador',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  TC: {
    country: 'Turks and Caicos Islands',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  TT: {
    country: 'Trinidad and Tobago',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  UY: {
    country: 'Uruguay',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  VC: {
    country: 'Saint Vincent and the Grenadines',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  VE: {
    country: 'Venezuela, Bolivarian Republic of',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  VG: {
    country: 'Virgin Islands, British',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
  VI: {
    country: 'Virgin Islands, U.S.',
    region: 'LATAM',
    number: defaultEMEANumbers,
  },
};

const apacNumbers = {
  AS: {
    country: 'American Samoa',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  AU: {
    country: 'Australia',
    region: 'APAC',
    number: defaultAustraliaNumbers,
  },
  BD: {
    country: 'Bangladesh',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  BN: {
    country: 'Brunei Darussalam',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  BT: {
    country: 'Bhutan',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  CC: {
    country: 'Cocos (Keeling) Islands',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  CN: {
    country: 'China',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  CX: {
    country: 'Christmas Island',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  FJ: {
    country: 'Fiji',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  FM: {
    country: 'Micronesia, Federated States of',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  GU: {
    country: 'Guam',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  HK: {
    country: 'Hong Kong',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  ID: {
    country: 'Indonesia',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  IN: {
    country: 'India',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  IO: {
    country: 'British Indian Ocean Territory',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  JP: {
    country: 'Japan',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  KH: {
    country: 'Cambodia',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  KI: {
    country: 'Kiribati',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  KP: {
    country: "Korea, Democratic People's Republic of",
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  KR: {
    country: 'Korea, Republic of',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  LA: {
    country: "Lao People's Democratic Republic",
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  LK: {
    country: 'Sri Lanka',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  MH: {
    country: 'Marshall Islands',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  MM: {
    country: 'Myanmar',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  MN: {
    country: 'Mongolia',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  MO: {
    country: 'Macao',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  MP: {
    country: 'Northern Mariana Islands',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  MV: {
    country: 'Maldives',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  MY: {
    country: 'Malaysia',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  NF: {
    country: 'Norfolk Island',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  NP: {
    country: 'Nepal',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  NR: {
    country: 'Nauru',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  NU: {
    country: 'Niue',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  NZ: {
    country: 'New Zealand',
    region: 'APAC',
    number: defaultNZNumbers,
  },
  PG: {
    country: 'Papua New Guinea',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  PH: {
    country: 'Philippines',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  PK: {
    country: 'Pakistan',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  PN: {
    country: 'Pitcairn',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  PW: {
    country: 'Palau',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  SB: {
    country: 'Solomon Islands',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  SG: {
    country: 'Singapore',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  TH: {
    country: 'Thailand',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  TK: {
    country: 'Tokelau',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  TL: {
    country: 'Timor-Leste',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  TO: {
    country: 'Tonga',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  TV: {
    country: 'Tuvalu',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  TW: {
    country: 'Taiwan, Province of China',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  UM: {
    country: 'United States Minor Outlying Islands',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  VN: {
    country: 'Vietnam',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  VU: {
    country: 'Vanuatu',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
  WS: {
    country: 'Samoa',
    region: 'APAC',
    number: defaultAPACNumbers,
  },
};

const naNumbers = {
  CA: {
    country: 'Canada',
    region: 'NA',
    number: defaultNANumbers,
  },
  US: {
    country: 'United States of America',
    region: 'NA',
    number: defaultNANumbers,
  },
};

interface CountryPhoneNumbers {
  [key: string]: {
    country: string;
    region: string;
    number: {
      spark: string;
      chart: string;
    };
  };
}

const countryPhoneNumbers: CountryPhoneNumbers = {
  ...emeaNumbers,
  ...latamNumbers,
  ...apacNumbers,
  ...naNumbers,
};

const countryCodeKey = 'notInEuLoaderCountry';
const lucidchartTargetNumbers = [
  ['888', '875', '4552'], // primary one used
  ['888', '875', '1867'],
  ['888', '875', '6970'],
  ['888', '875', '1683'],
  ['877', '210', '9890'],
  ['844', '465', '8243'],
  ['844', '314', '4788'],
];

const lucidsparkTargetNumbers = [['888', '875', '6369']];

const targetNumbersRegex = (product?: Products.Site) => {
  const numbers = product === 'chart' ? lucidchartTargetNumbers : lucidsparkTargetNumbers;

  return numbers.map(
    ([areaCode, firstThree, lastFour]) =>
      new RegExp(`(?:tel:)?\\+?1?[\\-\\s]?\\(?${areaCode}\\)?[\\-\\s]?${firstThree}[\\-\\s]?${lastFour}`),
  );
};

const localizePhoneNumbers = (phoneNumber?: string, product: Products.Site = 'chart') => {
  let countryCode = '';
  try {
    if (isBrowser()) {
      countryCode = localStorage.getItem(countryCodeKey) || '';
    }
  } catch (e) {
    console.error(`localizePhoneNumbers %cError: %c${e}`, 'color: red;', 'color: yellow;');
  }

  if (countryCode && countryCode in countryPhoneNumbers) {
    let currentPhoneNumber = phoneNumber;
    if (product === 'chart' || product === 'spark') {
      targetNumbersRegex(product).forEach(targetNumber => {
        if (currentPhoneNumber && currentPhoneNumber.match(targetNumber)) {
          let replacementPhoneNumber = countryPhoneNumbers[countryCode].number[product];
          if (currentPhoneNumber.startsWith('tel:')) {
            replacementPhoneNumber = `tel:${
              replacementPhoneNumber.startsWith('+') ? '' : '+'
            }${replacementPhoneNumber.replace(/\s/g, '')}`;
          }
          currentPhoneNumber = currentPhoneNumber.replace(targetNumber, replacementPhoneNumber);
        }
      });
    }

    return currentPhoneNumber || '';
  }

  if (!isBrowser() && phoneNumber && phoneNumber.startsWith('tel:')) {
    return '';
  }

  if (phoneNumber && phoneNumber.startsWith('tel:')) {
    // remove all parenthesis, hyphens, and spaces from the phone number
    phoneNumber = phoneNumber!.replace(isPhoneSeparatorCharacter, '');
  }

  return phoneNumber || '';
};

export default localizePhoneNumbers;
